﻿(function ($, d, ns) {
    ns.initFooterAccordion = function () {
        
        

        $('.js-hook-accordion-control').on('click', function () {
            if (Foundation.utils.is_small_only()) {
                var target = ".js-hook-accordion-content[data-accordion-content-id='" + $(this).attr('data-accordion-controller-for') + "']";
                if ($(target).hasClass('open')) {
                    $(target).removeClass('open');
                    $(this).removeClass('open');
                } else {
                    $('.js-hook-accordion-content.open').removeClass('open');
                    $('.js-hook-accordion-control.open').removeClass('open');
                    $(target).toggleClass('open');
                    $(this).addClass('open');
                }
            }
        });
    };

    $(d).ready(function () {
        ns.initFooterAccordion();
    });


})(jQuery, document, Crafted.Utilities);